import { styled } from '@mui/system';
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Typography } from '@mui/material';
import InputField from '#component/form/input';

export const StyledAccordion = styled(Accordion, {
  shouldForwardProp: prop => prop !== 'hasError'
})(({ theme, hasError }) => ({
  ...(hasError && {
    border: `2px solid ${theme.palette.error.main}`
  })
}));

export const PanelSummary = styled(AccordionSummary)(() => ({
  '& > div': {
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}));

export const TitleContainer = styled('div')(() => ({
  display: 'flex'
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 24,
  height: 24,
  fontSize: 'small'
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1)
}));

export const PanelDetails = styled(AccordionDetails)(() => ({
  flexDirection: 'column'
}));

export const StyledField = styled(InputField)(({ theme }) => ({
  margin: theme.spacing(0),
  width: '100%'
}));

export const FieldsGroupCnt = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(2),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  },
  [theme.breakpoints.up('sm')]: {
    alignItems: 'center'
  }
}));
